import Vue from "vue";
import Router from "vue-router";

// Layout Admin Dashboard
import Default from "./views/Layout";
import Home from "./views/Home.vue";
import OrderDisplay from "./views/OrderDisplay";

// Internal Staff
import UserListStaff from "./views/UserManagement/AdminAndStaff/List";
import UserCreateStaff from "./views/UserManagement/AdminAndStaff/Create";
import UserEditStaff from "./views/UserManagement/AdminAndStaff/Edit";

// Customer
import UserListOwner from "./views/Customer/List";
import UserCreateOwner from "./views/Customer/Create";
import UserEditOwner from "./views/Customer/Edit";

// Customer
import CustomerNewList from "./views/CustomerNew/List";
import CustomerNewEdit from "./views/CustomerNew/Edit";

// Print
import PrintCustomerNew from "./views/CustomerNew/Print";

// Customer
import LoyaltyPuchaseList from "./views/LoyaltyPuchase/List";
import LoyaltyPuchaseEdit from "./views/LoyaltyPuchase/Edit";

// Product
import ListProduct from "./views/Product/List";
import CreateProduct from "./views/Product/Create";
import EditProduct from "./views/Product/Edit";

// Pushcart Product
import ListPushcartProduct from "./views/PushcartProduct/List";
import CreatePushcartProduct from "./views/PushcartProduct/Create";

// Category
import CategoryList from "./views/Category/List";
import CategoryCreate from "./views/Category/Create";
import CategoryEdit from "./views/Category/Edit";

// Principal
import PrincipalList from "./views/Principal/List";

// Brand
import BrandList from "./views/Brand/List";
import BrandEdit from "./views/Brand/Edit";
import BrandCreate from "./views/Brand/Create";

// Promo & Voucher
import ListPromo from "./views/Promo/List";
import CreatePromo from "./views/Promo/Create";
import EditPromo from "./views/Promo/Edit";
import DuplicatePromo from "./views/Promo/Duplicate";

// Order
import ListOrder from "./views/Order/List";
import EditOrder from "./views/Order/Edit";

// Report
import ListReport from "./views/Report/List";

// Shopping Cart
import ValidationShoppingCart from "./views/ShoppingCart/ValidationShoppingCart";

// Order
import ListRetur from "./views/Retur/List";
import EditRetur from "./views/Retur/Edit";

// Print
import PrintReturDetail from "./views/Retur/Print";

// Terms of Service
import EditTermsOfService from "./views/TermOfService/Edit";
import Term from "./views/TermOfService";

// Branch
import BranchList from "./views/Branch/List";

// Login
import Login from "./views/Auth";

// Reset Password
import ResetPassword from "./views/ResetPassword";
import SuccessResetPassword from "./views/ResetPassword/SuccessResetPassword";

// Faq
import Faq from "./views/Faq";

// Contact Us
import ContactUs from "./views/ContactUs";

// Banner
import BannerList from "./views/Banner/List";
import BannerEdit from "./views/Banner/Edit";
import BannerCreate from "./views/Banner/Create";

// PPN Management
import PPN from "./views/PPN/Edit";

// Conversion Point
import ConversionPoint from "./views/ConversionPoint/Edit";

// Loyalty Item
import LoyaltyItemList from "./views/LoyaltyItem/List";
import LoyaltyItemCreate from "./views/LoyaltyItem/Create";
import LoyaltyItemEdit from "./views/LoyaltyItem/Edit";

Vue.use(Router);

export const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Default,
      redirect: "/home",
      children: [
        {
          path: "/home",
          meta: "List",
          component: Home,
        },
        {
          path: "banner",
          redirect: "/banner",
          meta: { title: "Banner", name: "Banner" },
          name: "banner",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: { title: "Banner", name: "List of Banner" },
              name: "banner-list",
              component: BannerList,
            },
            {
              path: "edit/:id",
              meta: { title: "Banner", name: "Edit Banner" },
              name: "banner-edit",
              props: true,
              component: BannerEdit,
            },
            {
              path: "create",
              meta: { title: "Banner", name: "Create Banner" },
              name: "banner-create",
              props: true,
              component: BannerCreate,
            },
          ],
        },
        {
          path: "/staff",
          redirect: "/staff",
          meta: { title: "Staff & Admin", name: "Staff Account" },
          name: "staff",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: {
                title: "List",
                name: "List of Staff Account",
              },
              name: "staff-list",
              component: UserListStaff,
            },
            {
              path: "create",
              meta: { title: "Create", name: "Create Staff Account" },
              name: "staff-create",
              component: UserCreateStaff,
            },
            {
              path: "edit/:id",
              meta: { title: "Edit", name: "Edit Staff Account" },
              name: "staff-edit",
              props: true,
              component: UserEditStaff,
            },
          ],
        },
        {
          path: "/customer",
          redirect: "/customer",
          meta: { title: "Customer", name: "Customer Account" },
          name: "customer",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: { title: "Customer", name: "List of Customer Account" },
              name: "customer-list",
              component: UserListOwner,
            },
            {
              path: "create",
              meta: { title: "Customer", name: "Create Customer Account" },
              name: "customer-create",
              component: UserCreateOwner,
            },
            {
              path: "edit/:id",
              meta: { title: "Customer", name: "Edit Customer Account" },
              name: "customer-edit",
              props: true,
              component: UserEditOwner,
            },
          ],
        },
        {
          path: "/customer-new",
          redirect: "/customer-new",
          meta: { title: "Customer Baru", name: "Customer Baru" },
          name: "customer-baru",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: { title: "Customer Baru", name: "List of Customer Baru" },
              name: "customer-new-list",
              component: CustomerNewList,
            },
            {
              path: "edit/:id",
              meta: { title: "Customer Baru", name: "Edit Customer Baru" },
              name: "customer-new-edit",
              props: true,
              component: CustomerNewEdit,
            },
          ],
        },
        {
          path: "/loyalty-purchase",
          redirect: "/loyalty-purchase",
          meta: { title: "Loyalty Purchase", name: "Loyalty Purchase" },
          name: "loyalty-purchase",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: {
                title: "Loyalty Purchase",
                name: "List of Loyalty Purchase",
              },
              name: "loyalty-purchase-list",
              component: LoyaltyPuchaseList,
            },
            {
              path: "edit/:id",
              meta: {
                title: "Loyalty Purchase",
                name: "Edit Loyalty Purchase",
              },
              name: "loyalty-purchase-edit",
              props: true,
              component: LoyaltyPuchaseEdit,
            },
          ],
        },
        {
          path: "product",
          redirect: "/product",
          meta: { title: "Product", name: "Product" },
          name: "product",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: { title: "Product", name: "List of Product" },
              name: "product-list",
              component: ListProduct,
            },
            {
              path: "create",
              meta: { title: "Product", name: "Create Product" },
              name: "product-create",
              component: CreateProduct,
            },
            {
              path: "edit/:id",
              meta: { title: "Product", name: "Edit Product" },
              name: "product-edit",
              props: true,
              component: EditProduct,
            },
          ],
        },
        {
          path: "pushcartProduct",
          redirect: "/pushcartProduct",
          meta: { title: "Pushcart Product", name: "Pushcart Product" },
          name: "pushcartProduct",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: {
                title: "Pushcart Product",
                name: "List of Pushcart Product",
              },
              name: "pushcartProduct-list",
              component: ListPushcartProduct,
            },
            {
              path: "create",
              meta: {
                title: "Pushcart Product",
                name: "Create Pushcart Product",
              },
              name: "pushcartProduct-create",
              component: CreatePushcartProduct,
            },
          ],
        },
        {
          path: "category",
          redirect: "/category",
          meta: { title: "Category", name: "Category" },
          name: "category",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: { title: "Category", name: "List of Category" },
              name: "category-list",
              component: CategoryList,
            },
            {
              path: "create",
              meta: { title: "Category", name: "Create Category" },
              name: "category-create",
              component: CategoryCreate,
            },
            {
              path: "edit/:id",
              meta: { title: "Category", name: "Edit Category" },
              name: "category-edit",
              props: true,
              component: CategoryEdit,
            },
          ],
        },
        {
          path: "brand",
          redirect: "/brand",
          meta: { title: "Brand", name: "Brand" },
          name: "brand",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: { title: "Brand", name: "List of Brand" },
              name: "brand-list",
              component: BrandList,
            },
            {
              path: "edit/:id",
              meta: { title: "Brand", name: "Edit Brand" },
              name: "brand-edit",
              props: true,
              component: BrandEdit,
            },
            {
              path: "create",
              meta: { title: "Brand", name: "Create Brand" },
              name: "brand-create",
              props: true,
              component: BrandCreate,
            },
          ],
        },
        {
          path: "/principal",
          redirect: "/principal",
          meta: { title: "Principal", name: "Principal" },
          name: "principal",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: { title: "Principal", name: "List of Principal" },
              name: "principal-list",
              component: PrincipalList,
            },
          ],
        },
        {
          path: "promovoucher",
          redirect: "/promovoucher",
          meta: { title: "Promo & Voucher", name: "Promo & Voucher" },
          name: "promo",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: {
                title: "Promo & Voucher",
                name: "List of Promo & Voucher",
              },
              name: "promo-list",
              component: ListPromo,
            },
            {
              path: "create",
              meta: {
                title: "Promo & Voucher",
                name: "Create Promo & Voucher",
              },
              name: "promo-create",
              component: CreatePromo,
            },
            {
              path: "edit/:promoType/:id",
              meta: { title: "Promo & Voucher", name: "Edit Promo & Voucher" },
              name: "promo-edit",
              props: true,
              component: EditPromo,
            },
            {
              path: "duplicate/:promoType/:id",
              meta: {
                title: "Promo & Voucher",
                name: "Duplicate Promo & Voucher",
              },
              name: "promo-duplicate",
              props: true,
              component: DuplicatePromo,
            },
          ],
        },
        {
          path: "conversionpoint",
          redirect: "/conversionpoint",
          meta: { title: "Konversi Point", name: "Konversi Point" },
          name: "conversion",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: {
                title: "Konversi Point",
                name: "Setting Konversi Point",
              },
              name: "conversion-edit",
              component: ConversionPoint,
            },
          ],
        },
        {
          path: "/loyaltyitem",
          redirect: "/loyaltyitem",
          meta: { title: "Loyalty Item", name: "Loyalty Item" },
          name: "loyaltyitem",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: {
                title: "List",
                name: "List of Loyalty Item",
              },
              name: "loyaltyitem-list",
              component: LoyaltyItemList,
            },
            {
              path: "create",
              meta: { title: "Create", name: "Create Loyalty Item" },
              name: "loyaltyitem-create",
              component: LoyaltyItemCreate,
            },
            {
              path: "edit/:id",
              meta: { title: "Edit", name: "Edit Loyalty Item" },
              name: "loyaltyitem-edit",
              props: true,
              component: LoyaltyItemEdit,
            },
          ],
        },
        {
          path: "order",
          redirect: "/order",
          meta: { title: "Order", name: "Order" },
          name: "order",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: { title: "Order", name: "List of Order" },
              name: "order-list",
              component: ListOrder,
            },
            {
              path: "edit/:oracleCustomerId/:orderId",
              meta: { title: "Order", name: "Edit Order" },
              name: "order-edit",
              props: true,
              component: EditOrder,
            },
          ],
        },
        {
          path: "reports",
          redirect: "/reports",
          meta: { title: "Report", name: "Report" },
          name: "reports",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: { title: "Report", name: "Sales Report" },
              name: "report-list",
              component: ListReport,
            },
          ],
        },
        {
          path: "validation-shopping-cart",
          redirect: "/validation-shopping-cart",
          meta: {
            title: "Validation Shopping Cart",
            name: "Validation Shopping Cart",
          },
          name: "validation-shopping-cart",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: {
                title: "Validation Shopping Cart",
                name: "Validation Shopping Cart",
              },
              name: "validation-shopping-cart-list",
              component: ValidationShoppingCart,
            },
          ],
        },
        {
          path: "retur",
          redirect: "/retur",
          meta: { title: "Retur", name: "Retur" },
          name: "retur",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: { title: "Retur", name: "List of Retur" },
              name: "retur-list",
              component: ListRetur,
            },
            {
              path: "edit/:oracleCustomerId/:returId",
              meta: { title: "Retur", name: "Edit Retur" },
              name: "retur-edit",
              props: true,
              component: EditRetur,
            },
          ],
        },
        {
          path: "termsofservice",
          redirect: "/termsofservice",
          meta: { title: "Term Of Service", name: "Term Of Service" },
          name: "termsofservice",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: {
                title: "Terms Of Service",
                name: "Edit Terms Of Service",
              },
              name: "termsofservice-edit",
              component: EditTermsOfService,
              props: true,
            },
          ],
        },
        {
          path: "/order-display",
          meta: "List",
          component: OrderDisplay,
        },
        {
          path: "tax",
          redirect: "/tax",
          meta: { title: "PPN Management", name: "PPN Management" },
          name: "tax",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: {
                title: "PPN Management",
              },
              name: "tax",
              component: PPN,
            },
          ],
        },
        {
          path: "branch",
          redirect: "/branch",
          meta: { title: "Branch", name: "Branch" },
          name: "branch",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              meta: { title: "Branch", name: "List Branch" },
              name: "branch-list",
              component: BranchList,
            },
          ],
        },
      ],
    },
    {
      path: "/print-customer-new",
      name: "print-customer-new",
      component: PrintCustomerNew,
    },
    {
      path: "/print-retur-detail",
      name: "print-retur-detail",
      component: PrintReturDetail,
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/reset-password/success",
      name: "reset-password-seccess",
      component: SuccessResetPassword,
    },
    {
      path: "/reset-password/:resetToken",
      name: "reset-password",
      component: ResetPassword,
    },
    {
      path: "/faq",
      name: "faq",
      component: Faq,
    },
    {
      path: "/privacy-policy",
      name: "term",
      component: Term,
    },
    {
      path: "/contact-us",
      name: "contact-use",
      component: ContactUs,
    },
    {
      path: "*",
      redirect: "/home",
    },
  ],
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/login", "/register"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("user");
  const publicPagesNotAuth = [
    "/faq",
    "/privacy-policy",
    "/reset-password/success",
    `/reset-password/${to.params.resetToken}`,
  ];

  if (publicPagesNotAuth.includes(to.path)) {
    next();
  } else if (authRequired && !loggedIn) {
    return next("/login");
  } else if (!authRequired && loggedIn) {
    return next("/");
  }
  next();
});
